// Geometry for the camera's opening move: it waits far out on +Z looking
// straight at the sun, then flies in a straight line to its home position.

/** Where the camera waits for the doors to open. */
export const LOBBY_CAMERA_START = { x: 0, y: 0, z: 10000 };

/**
 * Distance from the sun to the camera's home position. This is the radius the
 * home has always had — Math.hypot(107.25, 96.5) — kept so that moving the home
 * round to the diagonal does not change how far the camera flies.
 */
export const HOME_DISTANCE = Math.hypot(107.25, 96.5);

/**
 * Yaw the camera rests at once it arrives home. From a position centred between
 * +X and +Z the sun sits 45° round from -Z, so the resting yaw is the diagonal
 * itself — which is also what looking at the sun from there produces, so the
 * flight ends on the resting orientation instead of snapping to it.
 */
export const SUN_HOME_YAW = Math.PI / 4;

/**
 * The camera's home: centred between the +X and +Z axes at `radius` from the
 * sun, so the camera looks at the sun along a clean diagonal.
 */
export function diagonalHomePosition(radius = HOME_DISTANCE) {
  const offset = radius * Math.SQRT1_2;

  return { x: offset, y: 0, z: offset };
}
